import { render, staticRenderFns } from "./RowSubheader.vue?vue&type=template&id=7332d45e&"
import script from "./RowSubheader.vue?vue&type=script&lang=js&"
export * from "./RowSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports